// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__15cVF","site":"index_site__3IoMh","page":"index_page__Q1flU","table":"index_table__1yEWL"};